import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import {
  SessionTimeOutComponent,
  SessionTimeOutContent
} from '@com-delta-idp/mnx-sitewide-shared-core-ui';
import { SessionTimeoutService } from '../../data-access/services/session-time-out/session-time-out.service';

@Component({
  selector: 'idp-session-time-out-wrapper',
  templateUrl: './session-time-out-wrapper.component.html',
  standalone: true,
  styleUrls: ['./session-time-out-wrapper.component.scss'],
  imports: [CommonModule, SessionTimeOutComponent]
})
export class SessionTimeOutWrapperComponent {
  @Input() sessionTimeOutModelContent: SessionTimeOutContent =
    {} as SessionTimeOutContent;

  @Output() keepLoggedIn = new EventEmitter();
  emptyContentDetails: SessionTimeOutContent = {} as SessionTimeOutContent;

  constructor(public sessionTimeoutService: SessionTimeoutService) {}

  logout(): void {
    this.sessionTimeoutService.logOutAndRedirect(
      this.sessionTimeOutModelContent.slimheaderLogoUrl
    );
  }

  keepMeLoggedIn(): void {
    this.sessionTimeoutService.keepMeLoggdIn();
    this.keepLoggedIn.emit();
  }
}
